'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppHeader = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _icon = require('@hixme-ui/icon');

var _icon2 = _interopRequireDefault(_icon);

var _StyledHeaderContainer = require('./StyledHeaderContainer');

var _StyledHeaderContainer2 = _interopRequireDefault(_StyledHeaderContainer);

var _StyledIcon = require('./StyledIcon');

var _StyledIcon2 = _interopRequireDefault(_StyledIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AppHeader = exports.AppHeader = function AppHeader(_ref) {
  var children = _ref.children,
      fixed = _ref.fixed,
      toggleSidebar = _ref.toggleSidebar,
      open = _ref.open,
      sidebarWidth = _ref.sidebarWidth;
  return _react2.default.createElement(
    _StyledHeaderContainer2.default,
    { open: open, fixed: fixed, sidebarWidth: sidebarWidth },
    _react2.default.createElement(
      _StyledIcon2.default,
      { onClick: toggleSidebar },
      _react2.default.createElement(_icon2.default, { menu: true, light: true, size: 1.6 })
    ),
    children
  );
};

AppHeader.propTypes = {
  children: _propTypes2.default.node,
  fixed: _propTypes2.default.bool,
  toggleSidebar: _propTypes2.default.func,
  open: _propTypes2.default.bool,
  sidebarWidth: _propTypes2.default.string

  /* eslint-disable no-console */
};AppHeader.defaultProps = {
  children: null,
  fixed: true,
  toggleSidebar: function toggleSidebar() {
    return console.error('AppHeader: Sidebar toggle implementation not found');
  },
  open: false,
  sidebarWidth: '225px'
};

exports.default = AppHeader;
//# sourceMappingURL=AppHeader.js.map


//////////////////
// WEBPACK FOOTER
// ../app-layout/lib/components/AppHeader/AppHeader.js
// module id = 265
// module chunks = 0